import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例，配合vue.config.js代理
const service = axios.create({
  baseURL: '/', // 基础路径，结合代理转发到后端
  timeout: 10000 // 延长超时时间，避免请求超时
})

// 请求拦截器：无额外逻辑，确保请求正常发送
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.error('请求拦截器错误:', error)
    Message.error('请求发起失败，请检查网络')
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理返回结果
service.interceptors.response.use(
  response => {
    const res = response.data
    // 后端返回code=200为成功，其他视为失败
    if (res.code !== 200 && res.code !== undefined) {
      Message.error(res.msg || '操作失败')
      return Promise.reject(res)
    }
    return res
  },
  error => {
    console.error('响应拦截器错误:', error)
    Message.error('服务器响应失败，请重试')
    return Promise.reject(error)
  }
)

export default service